module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-nav grid",
    class: _vm.rootClasses
  }, [_c('transition-group', {
    staticClass: "main-nav--animation-root",
    attrs: {
      "name": "trs-main-nav-switch",
      "tag": "div"
    }
  }, [(_vm.isCompact) ? _c('div', {
    key: "fixed",
    staticClass: "main-nav--wrap main-nav--wrap__fixed",
    style: (_vm.scrollLockStyles)
  }, [_c('div', {
    staticClass: "main-nav--wrapper grid--container"
  }, [_c('cmp-main-nav-items-partial', {
    attrs: {
      "logo-url": _vm._f("static")('img/sib_logo.svg'),
      "facet": "fixed",
      "is-fixed": true,
      "structure": _vm.structure
    }
  })], 1)]) : _c('div', {
    key: "base",
    staticClass: "main-nav--wrap main-nav--wrap__base"
  }, [_c('div', {
    staticClass: "main-nav--wrapper grid--container"
  }, [_c('cmp-main-nav-items-partial', {
    attrs: {
      "logo-url": _vm._f("static")('img/sib_logo_claim.svg'),
      "facet": "base",
      "structure": _vm.structure
    }
  })], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46393c78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46393c78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/main-nav/index.vue
// module id = 539
// module chunks = 7